import axios from 'axios';
import { adminInstance } from '../../config/axios.js';

export const getActiveUsersAllChats = async (userId) => {
  try {
    const response = await adminInstance().post(
      `/api/admin/getActiveUsersAllChats`,
      {
        userId,
      }
    );
    return response?.data;
  } catch (error) {
    console.log('Error in getActiveUsersAllChats api =>', error);
    return error.response.data;
  }
};

export const getUserNotification = async (activeUser) => {
  try {
    let activeUserObj = { activeUser };
    const response = await adminInstance().post(
      `/api/admin/getUsersNotification`,
      activeUserObj
    );
    return response.data;
  } catch (error) {
    console.log('Error in getChats api =>', error);
    return error?.response?.data;
  }
};

export const modifyActiveRead = async (userId) => {
  try {
    const response = await adminInstance().post(`/api/admin/modifyActiveRead`, {
      userId,
    });
    return response?.data;
  } catch (error) {
    console.log('Error in getActiveUsersAllChats api =>', error);
    return error.response.data;
  }
};

export const getUserSearched = async (searchInput, cancelToken) => {
  try {
    const response = await adminInstance().post(
      `/api/admin/searchInputChat`,
      { searchInput },
      { cancelToken }
    );
    return response?.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request canceled', error.message);
    } else {
      return error?.response?.data;
    }
  }
};

export const decrementNotificationAPI = async (payload) => {
  try {
    const response = await adminInstance().post(
      `/api/admin/decrementNotification`,
      payload
    );
    return response?.data;
  } catch (error) {
    console.log('Error in decrement notification api =>', error);
    return error?.response?.data;
  }
};

export const clearUserSupportChat = async (userId) => {
  try {
    const response = await adminInstance().post(
      `/api/admin/clearUserSupportChat`,
      {
        userId,
      }
    );
    return response?.data;
  } catch (error) {
    console.log('Error in clearUserSupportChat api =>', error);
    return error.response.data;
  }
};
